import {useEffect, useState} from "react";
import {BridgeFee, estimateSendFee} from "../api/erc20";
import {networks} from "../pages/bridge/networks";
import {parseUnits} from "viem";
import {getTokenConfig} from "../pages/bridge/utils";
import {useBridge} from "../providers/BridgeDataProvider";

export const useFeeEstimate = (params: {
  userAddress?: string
  erc20Address?: string
  amount?: string
  chainId?: number
}) => {
  const { tokens } = useBridge()

  const [fee, setFee] = useState<BridgeFee>()

  const loadData = async () => {
    if(!params.erc20Address || !params.amount || !params.userAddress) {
      setFee(undefined)
      return
    }

    try {
      const tokenConfig = getTokenConfig(tokens, params.erc20Address);

      if(!tokenConfig) {
        throw new Error('No token config')
      }

      const amount = parseUnits(params.amount, +tokenConfig.decimals)
      const adapterParams =
        '0x0001000000000000000000000000000000000000000000000000000000000007a120';

      const feeData = await estimateSendFee(
        tokenConfig.proxyERC20,
        networks.HARMONY.layerzero.chainId,
        params.userAddress,
        amount,
        false,
        adapterParams,
        params.chainId
      )
      setFee(feeData)
    } catch(e) {
      console.error('useFeeEstimate: failed to load fee', e)
      setFee(undefined)
    }
  }

  useEffect(() => {
    if(tokens.length > 0) {
      loadData()
    }
  }, [tokens, params.amount, params.erc20Address, params.userAddress, params.chainId]);

  return {
    data: fee,
    refetch: loadData
  }
}
